// export const baseUrl = mymediatracker;
export const BASE_URL = process.env.REACT_APP_BASE_URL;

// reCAPTCHA site key
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

// Google OAuth client ID (Web)
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// maintenance mode (disabling media creation)
export const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === 'true';